import { getInitialState } from './state';
import Vue from 'vue';

const mutations = {
  SET_CLEAR_VALIDATION(state) {
    Object.assign(state, getInitialState());
  },

  SET_VALIDATION_URL_TOKEN(state, urlToken) {
    Vue.set(state.data, 'urlToken', urlToken);
  },

  SET_VALIDATION_CONTACT_TYPE(state, contactType) {
    state.data.chosenContactType = contactType;
  },

  SET_VALIDATION_CONTACT_SELECTED(state, phone) {
    state.data.contactSelected = phone;
  },

  SET_MESSAGE(state, message) {
    state.data.message = message;
  },
};

export default mutations;
